var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
/*
 * The families a family → item picker has open. Seeded from the families of
 * the picked items, and moved back to them whenever the pick changes — also
 * when it is made somewhere else, e.g. in the other picker for the same node
 * (sidebar vs. in-scene overlay) or by undo. In between, the user is free to
 * browse other families.
 */
export var useOpenFamilies = function (pickedFamilies) {
    var _a = __read(useState(pickedFamilies), 2), openFamilies = _a[0], setOpenFamilies = _a[1];
    var pickedFamiliesKey = pickedFamilies.join("\n");
    useEffect(function () {
        if (pickedFamiliesKey)
            setOpenFamilies(pickedFamiliesKey.split("\n"));
    }, [pickedFamiliesKey]);
    return [openFamilies, setOpenFamilies];
};
